import React, {Component} from 'react';
import objeler from '../objeler';
import 'react-dropdown/style.css'
import {Datasource} from '../Functions/funcs';
import './modal.css'
import {Col, Container, Row} from 'react-bootstrap';
import ScriptProperties from "./scriptProperties";
import {
    createEmptyStructuredJsonSample,
    parseStructuredJsonSample,
    toPersistedStructuredJsonSample
} from '../Functions/structuredJsonBuilder';

const dataProviderItems = require('../../items/dataProviders.json');

class DocProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            activeFontFamily: "Open Sans",
            activeBold: "false"
        };
        objeler['ModalDocValues'] = {...objeler.ModalDocParameters};
        if (!objeler.ModalDocValues.StructuredJsonSample) {
            objeler.ModalDocValues.StructuredJsonSample = createEmptyStructuredJsonSample();
        }
    };

    onStructuredJsonFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = event => {
            const sample = parseStructuredJsonSample(file.name, event.target.result);
            objeler.ModalDocValues.StructuredJsonSample = toPersistedStructuredJsonSample(sample);
            this.setState({ structuredJsonSample: sample });
        };
        reader.readAsText(file);
    }

    clearStructuredJsonSample = () => {
        const sample = createEmptyStructuredJsonSample();
        objeler.ModalDocValues.StructuredJsonSample = sample;
        this.setState({ structuredJsonSample: sample });
    }

    updateScriptValue(e) {
        objeler.ModalDocValues.Script = e.target.value;
    }

    onChangeIsScript(e) {
        this.setState({value: e.target.value});
        objeler.ModalDocValues.IsScript = e.target.checked;
    }

    render() {
        const pStyle = {
            height: "16px",
            color: "#000000",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const textStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const divStyle = {
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const dataSourceStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const comboStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0",
            vAlign: "middle"
        };
        return (
            <div style={divStyle}>
                <Container>
                    {this.renderStructuredJsonSamplePanel()}
                    <Row>
                        <Col sm>Author :</Col>
                        <Col sm>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.Author}
                        onChange={(e) => objeler.ModalDocValues.Author = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                        <Col sm>Subject :</Col>
                        <Col sm>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.Subject}
                        onChange={(e) => objeler.ModalDocValues.Subject = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                        <Col sm={0}>Title :</Col>
                        <Col sm={0}>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.Title}
                        onChange={(e) => objeler.ModalDocValues.Title = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                    </Row>
                    <Row><br></br> </Row>
                    <Row>
                        <Col sm={2}>Keywords :</Col>
                        <Col sm={2}>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.Keywords}
                        onChange={(e) => objeler.ModalDocValues.Keywords = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                        <Col sm={2}>Item Count Per Page :</Col>
                        <Col sm={2}>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.ItemCountPerDoc}
                        onChange={(e) => objeler.ModalDocValues.ItemCountPerDoc = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                    </Row>
                    <Row><Col><br></br></Col></Row>
                    <Row>
                        <Col sm={2}>Enable Outline:</Col>
                        <Col sm={2}>
                            <input type="checkbox" id="chkOutline" name=""
                                   style={{display: "inline-block"}}
                                   onChange={(e) => objeler.ModalDocValues.Outline = e.target.checked}
                                   defaultChecked={this.props.DocProps.Outline}/>
                        </Col>
                        <Col sm={2}>Outline Title:</Col>
                        <Col sm={2}>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.OutlineTitle}
                        onChange={(e) => objeler.ModalDocValues.OutlineTitle = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2}>Outline Item:</Col>
                        <Col sm={2}>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.OutlineItem}
                        onChange={(e) => objeler.ModalDocValues.OutlineItem = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                        <Col sm={2}>Outline DataSource:</Col>
                        <Col sm={2}>
              <textarea name="TextArea1" id="TextArea1"
                        ref={abc => this.child = abc}
                        defaultValue={this.props.DocProps.OutlineDataSource}
                        onChange={(e) => objeler.ModalDocValues.OutlineDataSource = e.target.value}
                        style={textStyle} rows="1" cols="20" spellCheck="false">
              </textarea>
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                    <Row><Col><br></br></Col></Row>
                    <Row>
                    </Row>
                    <Row>
                        <Col style={{width: '690px', alignContent: 'right'}}>
                            <Container>
                                <Row sm={4}>
                                    <Col>
                                        <Container>
                                            <Row>
                                                <Col sm>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.Encrypted = e.target.checked}
                                                               defaultChecked={this.props.DocProps.Encrypted}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Encrypted</label>
                                                    </div>
                                                </Col>
                                                <Col sm><p style={pStyle}>&nbsp;Password:</p></Col>
                                                <Col sm={2}>
                          <textarea name="TextArea1" id="TextArea1" autoComplete="off"
                                    ref={abc => this.child = abc}
                                    defaultValue={this.props.DocProps.EncryptPassword}
                                    onChange={(e) => objeler.ModalDocValues.EncryptPassword = e.target.value}
                                    style={textStyle} rows="1" cols="20" spellCheck="false">
                          </textarea>
                                                </Col>
                                                <Col> <br/></Col>
                                                <Col><br></br></Col>
                                                <Col><br></br></Col>
                                                <Col><br></br></Col>
                                                <Col><br></br></Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Container>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptPrint = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptPrint}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Print</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptLowQalityPrintX = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptLowQalityPrintX}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LowQalityPrintX</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptModifyContents = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptModifyContents}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ModifyContents</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptExtractContents = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptExtractContents}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ExtractContents</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptAnnotation = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptAnnotation}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Annotation</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptInteractive = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptInteractive}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Interactive</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptAccessibility = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptAccessibility}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Accessibility</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <div id="wb_Checkbox1">
                                                        <input type="checkbox" id="chkFill" name=""
                                                               style={{display: "inline-block"}}
                                                               onChange={(e) => objeler.ModalDocValues.EncryptAssembleDoc = e.target.checked}
                                                               defaultChecked={this.props.DocProps.EncryptAssembleDoc}/>
                                                        <label htmlFor="Checkbox1"
                                                               style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AssembleDoc</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                    <Col sm={6}>
                                        <ScriptProperties
                                            IsScript={objeler.ModalDocValues.IsScript}
                                            Script={objeler.ModalDocValues.Script}
                                            onChangeScript={e => this.updateScriptValue(e)}
                                            onChangeIsScript={e => this.onChangeIsScript(e)}
                                        />
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                        <Col>
                            <button
                                type="button"
                                onClick={() => Datasource()}
                                className="inline-block text-sm px-4 py-2 leading-none border rounded  text-white border-white hover:border-transparent bg-blue hover:bg-blue hover:bg-text-red mt-1 lg:mt-2"
                            >
                                Datasource
                            </button>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    renderStructuredJsonSamplePanel() {
        const sample = this.state.structuredJsonSample ||
            objeler.ModalDocValues.StructuredJsonSample ||
            createEmptyStructuredJsonSample();

        const panelStyle = {
            border: '1px solid #d0d7de',
            borderRadius: '4px',
            padding: '10px',
            marginBottom: '12px',
            backgroundColor: '#f8fafc'
        };

        const statusStyle = {
            color: sample.valid ? '#0f7b0f' : (sample.error ? '#b00020' : '#555'),
            fontSize: '12px',
            marginTop: '6px'
        };

        return (
            <Row>
                <Col>
                    <div style={panelStyle}>
                        <div style={{fontWeight: 'bold', marginBottom: '8px'}}>Structured JSON Sample</div>
                        <input
                            type="file"
                            accept=".json,application/json"
                            onChange={this.onStructuredJsonFileChange}
                        />
                        <button
                            type="button"
                            onClick={this.clearStructuredJsonSample}
                            style={{marginLeft: '8px'}}
                        >
                            Clear
                        </button>
                        <div style={statusStyle}>
                            {sample.valid
                                ? `${sample.fileName} loaded. ${sample.paths.length} JSON paths available.`
                                : (sample.error ? `Invalid JSON: ${sample.error}` : 'Upload a sample JSON file for guided bindings.')}
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
}

export default DocProperties;
